import { render } from "./DiscountsBasIndex.vue?vue&type=template&id=1dee8973&scoped=true"
import script from "./DiscountsBasIndex.vue?vue&type=script&lang=js"
export * from "./DiscountsBasIndex.vue?vue&type=script&lang=js"

import "./DiscountsBasIndex.vue?vue&type=style&index=0&id=1dee8973&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dee8973"]])

export default __exports__